export enum TankPlanCondition {
    Arrival = 1,
    Departure = 2,
    OperationsInCall = 3,
    LoadingOperations = 4,
    TransitOperations = 5,
    UnloadingOperations = 6,
}
